import React from 'react';
import { motion } from 'framer-motion';
import { MoveRight } from 'lucide-react';

const SocialImpactSection = () => {
  return (
    <section className="relative bg-white py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Left Section - Heading and Call to Action */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            {/* Subtitle */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
                <p className="text-xs sm:text-sm font-semibold text-[#2B2B2B] uppercase tracking-wider font-sans">
                SOCIAL SECTOR SPOTLIGHT
              </p>
            </motion.div>

            {/* Main Heading */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
              className="space-y-4"
            >
              <div className="space-y-2">
                <div className="flex items-baseline">
                
                  <div className="me-8 sm:me-10 md:me-12">
                  <span className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl me-2 sm:me-3 md:me-4 font-serif italic font-bold text-[#113861] ">
                    Clarity
                  </span>

                      <span className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-sans font-light text-[#113861] ">
                      for every
                    </span>
                    <br />
                    <span className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-sans font-light text-[#113861] ">
                      community
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Call to Action */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
              className="flex items-center space-x-2 cursor-pointer group hover:opacity-80 transition-opacity duration-200"
            >
              <span className="text-base sm:text-lg text-[#2B2B2B] font-medium font-sans flex items-center gap-2">
                Discover <em className="font-semibold font-sans not-italic">Social Impact Work</em> <MoveRight className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-black group-hover:translate-x-1 transition-transform duration-200 font-source font-regular" />
              </span>
            </motion.div>
          </motion.div>

          {/* Right Section - Descriptive Text */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="lg:pt-16"
          >
            <p className="text-base sm:text-lg text-[#000000] leading-relaxed max-w-lg font-sans">
              We partner with NGOs and grassroots groups to deliver our science-backed 
              assessments where they matter most. From rural classrooms to urban centres, 
              we create equitable access to clarity-driven tools and support.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SocialImpactSection;
